export default __webpack_public_path__ + "static/media/ourstorybanner.aaa8dd3d.jpg";